<template>
  <b-button variant="inverse-dark" @click="$refs.modal.show()">
    &nbsp;
    <!-- NOTE: add a space to align icon in center, can be remove in Vue 3, since Vue 3 allow multiple root node in a single component -->
    <i class="fa fa-link"></i>
    <!-- NOTE: b-modal should be move to the same level as b-button in Vue 3 -->
    <b-modal ref="modal" footer-class="d-flex justify-content-center">
      <template #modal-header="{ close }">
        <!-- Emulate built in modal header close button action -->

        <h5 class="m-0 align-self-center">{{ title }}</h5>
        <b-button size="sm" variant="link" class="text-dark" @click="close()">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 320 512"
            style="height: 20px"
          >
            <path
              d="M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z"
            />
          </svg>
        </b-button>
      </template>
      <b-textarea
        ref="url"
        v-b-tooltip.click="'已複製'"
        v-model="url"
        @click="copyAssignUrl"
        class="form-control"
      ></b-textarea>
      <slot name="qrcode"></slot>
      <template #modal-footer>
        <div class="modal-button-group">
          <div class="center-button">
            <slot name="qrcode-download-button"></slot>
          </div>
          <b-button variant="danger" @click="$refs.modal.hide()">
            關閉
          </b-button>
        </div>
      </template>
    </b-modal>
  </b-button>
</template>

<script>
export default {
  props: {
    url: {
      required: true,
      type: String,
    },
    title: {
      type: String,
    },
  },
  methods: {
    copyAssignUrl() {
      const inputDom = this.$refs.url;
      inputDom.select();
      document.execCommand("copy");
    },
  },
};
</script>

<style scoped>
.modal-button-group {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  position: relative;
}

.modal-button-group > .center-button {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>
